<div class="custom-container">
    <ng-content></ng-content>
</div>
